module.exports = __webpack_public_path__ + "images/emoji/eight_spoked_asterisk.11d50d5db945e2298f92.png";